import type { Price } from '../../../../codegen/types';
import { getAmount } from '../../../currencyHelper';
import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

interface LineItemData {
  productId: string;
  productName?: string;
  productColor?: string;
  productImage?: string;
  slug?: string;
  brand?: string;
  categoryName?: string;
  prices?: Price[];
  itemListId?: string;
  itemListName?: string;
  images: string[];
  key: string;
}

export function sendQuickAddEvent(lineItem: LineItemData, baseUrl: string) {
  const {
    productId,
    productName,
    productImage,
    productColor,
    brand,
    categoryName,
    itemListId,
    itemListName,
    prices,
    key,
    slug,
  } = lineItem;

  if (!productId) return;

  const pricesToUse = prices && prices.length > 0 ? prices : [];
  const [{ actualPrice, wasPrice, thenPrice }] = pricesToUse;
  const priceAmount = +getAmount(actualPrice?.centAmount);
  const wasPriceAmount = +getAmount(wasPrice?.centAmount);
  const thenPriceAmount = +getAmount(thenPrice?.centAmount);
  const currency = actualPrice?.currencyCode;
  const itemName = [productName, productColor].filter(Boolean).join(' ');
  const discountAmount = wasPriceAmount && priceAmount ? wasPriceAmount - priceAmount : 0;
  const url = baseUrl ? `${baseUrl}/${slug}/${key}-p` : undefined;

  const itemData = {
    item_id: productId,
    item_sku: productId,
    item_image_url: productImage,
    item_url: url,
    item_name: itemName || '',
    discount: discountAmount ? +discountAmount.toFixed(2) : '',
    index: 0,
    item_brand: brand ?? 'Clarks',
    item_category: categoryName,
    item_list_id: itemListId || '',
    item_list_name: itemListName,
    item_variant: productColor || '',
    price: priceAmount,
    quantity: 1,
    then_price: thenPriceAmount,
    was_price: wasPriceAmount,
  };

  sendDataLayerEvent(EventNamesType.quick_add, {
    ecommerce: {
      currency,
      value: priceAmount || 0,
      items: [itemData],
    },
  });
}
